import React from 'react';
import { useVideoConfig } from 'remotion';
import {
  BASE_SIZE,
  CAPTIONS_FONT_SIZE,
  CAPTIONS_FONT_WEIGHT,
  LINE_HEIGHT,
  LINES_PER_PAGE,
} from '../constants';
import { WaitForFonts } from '../fonts/WaitForFonts';
import { AudiogramProps } from '../schema';
import { PaginatedCaptions } from './PaginatedCaptions';

export const CaptionsDisplay: React.FC<AudiogramProps> = (props) => {
  const {
    variant,
    captions,
    captionsType,
    captionsTextColor,
    onlyDisplayCurrentSentence,
    audioOffsetInSeconds,
  } = props;

  const { fps, width, durationInFrames } = useVideoConfig();
  const audioOffsetInFrames = Math.round(audioOffsetInSeconds * fps);
  const textBoxWidth = width - BASE_SIZE * 2;

  if (!captions) {
    throw new Error('subtitles should have been provided through calculateMetadata');
  }

  return (
    <WaitForFonts>
      <div
        style={{
          lineHeight: `${LINE_HEIGHT}px`,
          width: textBoxWidth,
          fontWeight: CAPTIONS_FONT_WEIGHT,
          fontSize: CAPTIONS_FONT_SIZE,
          marginTop: BASE_SIZE * 1,
        }}
      >
        <PaginatedCaptions
          captions={captions}
          startFrame={audioOffsetInFrames}
          endFrame={audioOffsetInFrames + durationInFrames}
          linesPerPage={LINES_PER_PAGE}
          subtitlesTextColor={captionsTextColor}
          onlyDisplayCurrentSentence={onlyDisplayCurrentSentence}
          textBoxWidth={textBoxWidth}
          captionsType={captionsType}
        />
      </div>
    </WaitForFonts>
  );
};
